import type { Season } from '@losan/core';

interface Props {
  value: Season;
  options: Season[];
  onChange: (s: Season) => void;
}

/** Pill selector for the active sales season. Shown in the dashboard header. */
export function SeasonSelector({ value, options, onChange }: Props) {
  return (
    <div className="season-selector" role="tablist" aria-label="Temporada">
      {options.map((s) => (
        <button
          key={s}
          role="tab"
          aria-selected={value === s}
          className={value === s ? 'active' : ''}
          onClick={() => onChange(s)}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
